import { PageDsl, Params, Content, PageContext, MenuItem, ModalDsl, ModalContext } from '../types';
import axios from 'axios';
import { authentication } from '@ecosystem/newron-client-lib';
import { clientToImpersonate } from './impersonate';
import { SimpleMessageError } from '../design/error/simpleMessageError';
import { DEFAULT_ERROR_MESSAGE } from '../common/constants/error';
import { getFeatureFlagHeaders } from './featureFlags';

axios.defaults.headers.common['Accept'] = 'application/json';

export type ContextValues = Record<string, string[]>;

async function getPageDsl(url: string, context: PageContext): Promise<PageDsl> {
  const token = await authentication.getAccessToken();

  try {
    const response = await axios.post<PageDsl>(url, context, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(await clientToImpersonate()),
        ...(await getFeatureFlagHeaders()),
      },
    });

    if (!response.data) {
      throw new SimpleMessageError(DEFAULT_ERROR_MESSAGE);
    }
    return response.data;
  } catch (err) {
    throw new SimpleMessageError(err.response?.data ?? DEFAULT_ERROR_MESSAGE);
  }
}

async function getModalDsl(url: string, context: ModalContext): Promise<ModalDsl> {
  const token = await authentication.getAccessToken();

  try {
    const { data } = await axios.post<ModalDsl>(url, context, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(await clientToImpersonate()),
        ...(await getFeatureFlagHeaders()),
      },
    });
    return data;
  } catch (err) {
    throw new SimpleMessageError(err?.response?.data || DEFAULT_ERROR_MESSAGE);
  }
}

async function getComponentContents(url: string, contentParams: Params = {}): Promise<Content[]> {
  const token = await authentication.getAccessToken();

  try {
    const search = new URLSearchParams();
    Object.keys(contentParams).forEach(name => {
      const values = contentParams[name];
      values.forEach(value => {
        search.append(name, value);
      });
    });
    const response = await axios.get<Content[]>(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(await clientToImpersonate()),
        ...(await getFeatureFlagHeaders()),
      },
      params: search,
    });
    if (!response.data) {
      throw new SimpleMessageError(DEFAULT_ERROR_MESSAGE);
    }
    return response.data;
  } catch (err) {
    throw new SimpleMessageError(err?.response?.data || DEFAULT_ERROR_MESSAGE);
  }
}

async function getMenuItems(url: string, params: Params): Promise<MenuItem[]> {
  const token = await authentication.getAccessToken();

  try {
    const search = new URLSearchParams();
    Object.keys(params).forEach(name => {
      const values = params[name];
      values.forEach(value => {
        search.append(name, value);
      });
    });

    const { data } = await axios.get<MenuItem[]>(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(await clientToImpersonate()),
        ...(await getFeatureFlagHeaders()),
      },
      params: search,
    });

    return data;
  } catch (err) {
    throw new SimpleMessageError(err?.response?.data || DEFAULT_ERROR_MESSAGE);
  }
}

export const pageClient = {
  getPageDsl,
  getModalDsl,
  getComponentContents,
  getMenuItems,
};
